import { render, staticRenderFns } from "./SessionHeaderNav.vue?vue&type=template&id=52d38338&"
import script from "./SessionHeaderNav.vue?vue&type=script&lang=js&"
export * from "./SessionHeaderNav.vue?vue&type=script&lang=js&"
import style0 from "./SessionHeaderNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports